import { createFileRoute } from '@tanstack/react-router'
import { ChallengeManagement } from '../../../components/AdminChallenges'

export const Route = createFileRoute('/admin/challenges/')({
  component: () => <ChallengeManagement />,
})
